import { AnimationEvent, usePopup } from '../../hooks';
import { Portal } from '../../foundation';
import { TBottomSheetProps } from '@libs/types';
import React, { useCallback, useEffect, useEffectEvent, useState } from 'react';
import { flushSync } from 'react-dom';
import styles from './BottomSheet.module.css';

export const BottomSheet = ({ widgetId, modal, setBottomSheet, bottomSheets, WidgetsList }: TBottomSheetProps) => {
    const [animated, setAnimated] = useState(false);
    const [id, setId] = useState<string>('');
    const currentBottomSheet = bottomSheets?.[id];
    const { handlers, overlayRef, overlayClick } = usePopup(id && currentBottomSheet, setAnimated, modal);

    const updatePopup = useEffectEvent((i: string, wId?: string) => {
        if (wId) {
            setId(wId);
        } else if (i) {
            setAnimated(true);
        }
    });

    useEffect(() => {
        updatePopup(id, widgetId);
    }, [id, widgetId]);

    const closePopupAndClearState = useCallback(() => {
        setId('');
        setAnimated(false);
        setBottomSheet(undefined);
    }, [setBottomSheet]);

    const closePopup = useEffectEvent(() => {
        closePopupAndClearState();
    });

    useEffect(() => {
        if (!currentBottomSheet) {
            closePopup();
        }
    }, [currentBottomSheet]);

    const closeAnimationPopup = useCallback(
        (e: AnimationEvent<HTMLDivElement>) => {
            if (e?.animationName === 'getOutAnimation') {
                flushSync(() => {
                    closePopupAndClearState();
                });
            }
        },
        [closePopupAndClearState],
    );

    if (id && currentBottomSheet) {
        const popupBoxClassName = [styles.popupBox, animated && styles.popupBoxAnimated].filter(Boolean).join(' ');
        return (
            <Portal>
                <div id="bottom-sheet" {...handlers}>
                    <div className={styles.overlay} onClick={overlayClick}>
                        <div className={styles.popupOuter}>
                            <div className={popupBoxClassName} onAnimationEnd={closeAnimationPopup} ref={overlayRef}>
                                <div className={styles.popupBoxContentWrapper}>
                                    <div className={styles.popupBoxContent}>
                                        <WidgetsList uids={currentBottomSheet.uid} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Portal>
        );
    }
    return null;
};
